<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
    z-index="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <button class="appbar-pill locale-pill ms-3" v-bind="attrs" v-on="on">
        <v-icon size="14" color="#e65100">mdi-translate</v-icon>
        <span class="locale-label">{{ currentLocale }}</span>
      </button>
    </template>
    <v-list class="locale-menu">
      <v-list-item link @click="changeLocale('en')" :class="{ 'locale-active': currentLocale === 'EN' }">
        <v-list-item-icon class="me-2 my-auto">
          <span class="locale-flag">🇬🇧</span>
        </v-list-item-icon>
        <v-list-item-title>English</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="changeLocale('sq')" :class="{ 'locale-active': currentLocale === 'SQ' }">
        <v-list-item-icon class="me-2 my-auto">
          <span class="locale-flag">🇦🇱</span>
        </v-list-item-icon>
        <v-list-item-title>Shqip</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { setDocumentLang } from '@/utils/document';
import { loadLocaleMessagesAsync } from '@/i18n';
import { mdiTranslate } from '@mdi/js';

export default {
  data() {
    return {
      icons: {
        mdiTranslate,
      },
    };
  },
  computed: {
    currentLocale() {
      return (localStorage.getItem('locale') || 'sq').toUpperCase();
    },
  },
  created() {
    this.loadLocale();
  },
  methods: {
    loadLocale() {
      const localeLocalStorage = localStorage.getItem('locale');
      if (localeLocalStorage) {
        loadLocaleMessagesAsync(localeLocalStorage).then(() => {
          setDocumentLang(localeLocalStorage);
          this.$vuetify.lang.current = localeLocalStorage;
        });
      } else {
        localStorage.setItem('locale', 'sq');
        loadLocaleMessagesAsync('sq').then(() => {
          setDocumentLang('sq');
          this.$vuetify.lang.current = 'sq';
        });
      }
    },
    changeLocale(locale) {
      localStorage.setItem('locale', locale);
      loadLocaleMessagesAsync(locale).then(() => {
        setDocumentLang(locale);
        this.$vuetify.lang.current = locale;
      });
    },
  },
};
</script>

<style>
.appbar-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  background: rgba(0,0,0,0.06);
  border: none;
  cursor: pointer;
  transition: background 0.18s, transform 0.15s;
}
.appbar-pill:hover {
  background: rgba(0,0,0,0.12);
  transform: translateY(-1px);
}
.theme--dark .appbar-pill {
  background: rgba(255,255,255,0.1);
}
.theme--dark .appbar-pill:hover {
  background: rgba(255,255,255,0.18);
}
.locale-pill {
  padding: 0 10px;
  gap: 5px;
}
.locale-label {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.5px;
  font-family: 'Inter', sans-serif;
}
.theme--dark .locale-label { color: #e2e8f0; }
.locale-flag { font-size: 16px; line-height: 1; }
.locale-menu { min-width: 160px; }
.locale-active { background: rgba(230,81,0,0.08) !important; }
.locale-active .v-list-item__title { color: #e65100 !important; font-weight: 700; }

.locale-pill { background: rgba(230,81,0,0.12) !important; }
.locale-pill:hover { background: rgba(230,81,0,0.22) !important; }
.theme--dark .locale-pill { background: rgba(255,152,0,0.16) !important; }
.theme--dark .locale-pill:hover { background: rgba(255,152,0,0.26) !important; }
.theme--dark .locale-label { color: #FFB74D; }
</style>